import React from 'react';
import { Box, Container } from '@chakra-ui/react';
import MediaTable from '../components/tables/mediaTable';

export default function Media() {
  return (
    <Box sx={{ py: '20px' }}>
      <Container maxW="container.xl">
        <MediaTable />
      </Container>
    </Box>
  );
}
